import React from "react";

function Hero() {
  return (
    <section className="support-hero">
      <div className="container">
        <div className="support-hero-inner">
          <div className="support-hero-copy">
            <span className="support-badge">Support Portal</span>
            <h1>Search for answers or create a ticket instantly</h1>
            <p>
              Browse help topics, get quick guidance, and track active
              resolutions from one central support hub.
            </p>
            <div className="support-hero-search">
              <input placeholder="Eg. how do I activate F&O" />
              <button className="btn btn-primary">Search</button>
            </div>
            <div className="support-hero-links">
              <a href="/">Track account opening</a>
              <a href="/">Track segment activation</a>
              <a href="/">Intraday margins</a>
              <a href="/">Kite user manual</a>
            </div>
          </div>
          <div className="support-hero-panel">
            <h3>Featured articles</h3>
            <ol>
              <li>
                <a href="/">Current Takeovers and Delisting - January 2024</a>
              </li>
              <li>
                <a href="/">Latest Intraday leverages - MIS & CO</a>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
